module.exports = __webpack_public_path__ + "static/media/shapes_19.f8b5f9ac.svg";